import { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import HomePage from "./pages/HomePage";
import ContactPage from "./pages/ContactPage";
import LegalPage from "./pages/LegalPage";
import NotFoundPage from "./pages/NotFoundPage";
import ResearchPage from "./pages/ResearchPage";
import { AboutPage, ProductsPage, ServicesPage } from "./pages/StandardPages";
import { SiteFooter, SiteHeader } from "./components/SiteChrome";

function RouteAnnouncer() {
  const location = useLocation();

  useEffect(() => {
    const targetId = location.hash.slice(1);
    if (targetId) {
      requestAnimationFrame(() => document.getElementById(targetId)?.scrollIntoView({ block: "start" }));
      return;
    }
    const heading = document.querySelector("h1");
    heading?.setAttribute("tabindex", "-1");
    heading?.focus({ preventScroll: true });
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [location.pathname, location.hash]);

  return null;
}

export default function App() {
  return (
    <div className="site-shell">
      <a className="skip-link" href="#main-content">Skip to main content</a>
      <SiteHeader />
      <RouteAnnouncer />
      <main id="main-content">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services/" element={<ServicesPage />} />
          <Route path="/products/" element={<ProductsPage />} />
          <Route path="/about/" element={<AboutPage />} />
          <Route path="/research/" element={<ResearchPage />} />
          <Route path="/contact/" element={<ContactPage />} />
          <Route path="/privacy-policy/" element={<LegalPage type="privacy" />} />
          <Route path="/terms-conditions-of-use/" element={<LegalPage type="terms" />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      <SiteFooter />
    </div>
  );
}
